import { render, staticRenderFns } from "./SmsOriginatorRule.vue?vue&type=template&id=58cdd5d2&"
import script from "./SmsOriginatorRule.vue?vue&type=script&lang=ts&"
export * from "./SmsOriginatorRule.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports